import { getBrowserWidth } from 'owa-mail-store-actions';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
/**
 * Search box should be centered if feature flag is enabled and the browser
 * width is at least 1260px. This number should be kept in sync in with the CSS
 * media query selectors defined in OwaSuiteHeader.scss and Header.scss.
 */
export default function shouldCenterSearchBox() {
    return isMailFeatureEnabled('sea-centered') && getBrowserWidth() >= 1260;
}
//# sourceMappingURL=shouldCenterSearchBox.js.map